import { Link } from 'react-router-dom';
import { Linkedin, Twitter } from 'lucide-react';

const WHATSAPP_ICON = "https://customer-assets.emergentagent.com/job_d9a33add-2dfd-4326-bbed-949961573d64/artifacts/hx48xypq_whatsapp.png";
const LOCATION_ICON = "https://customer-assets.emergentagent.com/job_d9a33add-2dfd-4326-bbed-949961573d64/artifacts/qcdhf6rg_location.png";
const MAIL_ICON = "https://customer-assets.emergentagent.com/job_d9a33add-2dfd-4326-bbed-949961573d64/artifacts/wmk5drle_mail.png";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_7ca2cd33-9325-433c-b3f0-102d7d17319b/artifacts/tie58z5q_vfcs9rps_tridenterprise_logo_transparent.png";

const footerLinks = {
  services: [
    { name: 'Oracle ERP Implementation', path: '/services#erp' },
    { name: 'Custom Oracle Apps', path: '/services#custom' },
    { name: 'Cloud Migration', path: '/services#cloud' },
    { name: 'Managed Services', path: '/services#managed' },
  ],
  company: [
    { name: 'About Us', path: '/about' },
    { name: 'Case Studies', path: '/case-studies' },
    { name: 'Testimonials', path: '/testimonials' },
    { name: 'Contact', path: '/contact' },
  ],
  resources: [
    { name: 'Schedule Consultation', path: '/contact' },
    { name: 'Request Proposal', path: '/contact' },
  ],
};

export default function Footer() {
  return (
    <footer className="section-dark" data-testid="main-footer">
      {/* Main Footer Content */}
      <div className="container-custom py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-6">
              <img 
                src={LOGO_URL} 
                alt="Trid Enterprise Solutions" 
                className="w-[180px] h-auto"
              />
            </Link>
            <p className="text-slate-400 font-body text-sm leading-relaxed mb-6">
              Your trusted Oracle transformation partner. Delivering enterprise excellence through expert implementations, custom solutions, and managed services.
            </p>
            <div className="flex space-x-4">
              <a 
                href="https://www.linkedin.com/company/tridenterprise/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-slate-400 hover:text-oracle-red transition-colors"
                data-testid="footer-linkedin"
              >
                <Linkedin className="w-5 h-5" />
              </a>
              <a 
                href="https://twitter.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-slate-400 hover:text-oracle-red transition-colors"
                data-testid="footer-twitter"
              >
                <Twitter className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-heading text-lg font-bold text-white mb-6">Services</h4>
            <ul className="space-y-3">
              {footerLinks.services.map((link) => (
                <li key={link.name}>
                  <Link 
                    to={link.path}
                    className="text-slate-400 hover:text-white font-body text-sm transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-heading text-lg font-bold text-white mb-6">Company</h4>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.name}>
                  <Link 
                    to={link.path}
                    className="text-slate-400 hover:text-white font-body text-sm transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-heading text-lg font-bold text-white mb-6">Contact</h4>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <img src={LOCATION_ICON} alt="Location" className="w-5 h-5 flex-shrink-0 mt-0.5" />
                <span className="text-slate-400 font-body text-sm">
                  31, SVR Sadan,<br />
                  Road No 6, Jawahar Nagar,<br />
                  Hyderabad, Telangana,<br />
                  INDIA 500020
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <img src={WHATSAPP_ICON} alt="WhatsApp" className="w-5 h-5 flex-shrink-0" />
                <a href="https://wa.me/919160919609" target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-white font-body text-sm transition-colors">
                  +91 91 609 19 609
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <img src={MAIL_ICON} alt="Email" className="w-5 h-5 flex-shrink-0" />
                <a href="mailto:info@tridenterprise.com" className="text-slate-400 hover:text-white font-body text-sm transition-colors">
                  info@tridenterprise.com
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-slate-800">
        <div className="container-custom py-4 md:py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-3 md:space-y-0">
            <p className="text-slate-500 font-body text-xs md:text-sm text-center md:text-left">
              © {new Date().getFullYear()} Trid Enterprise Solutions. All rights reserved.
            </p>
            <div className="flex space-x-4 md:space-x-6">
              <Link to="/privacy" className="text-slate-500 hover:text-slate-300 font-body text-xs md:text-sm transition-colors">
                Privacy Policy
              </Link>
              <Link to="/terms" className="text-slate-500 hover:text-slate-300 font-body text-xs md:text-sm transition-colors">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
